import PrejoiningPage from "../components/Recruitment/Prejoining/PrejoiningPage";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider, App as AntApp } from "antd";
import { AuthProvider } from "../context/AuthContext";
import { SidebarProvider } from "../context/SidebarContext";
import { PageTitleProvider } from "../context/PageTitleContext";
import { SSEProvider } from "../context/SSEContext";
import AppRouter from "./AppRouter";
import "./App.scss";
import Store from "../context/store";
import ScrollToAnchor from "../components/Common/ScrollToAnchor";
import FeedbackWidgetLoader from "../components/Common/FeedbackWidgetLoader";
import NewVersionWatcher from "../components/Common/NewVersionWatcher";
import ApiAvailabilityWatcher from "../components/Common/ApiAvailabilityWatcher";
import MobileViewportGuard from "../components/Common/MobileViewportGuard";

const routerFutureFlags = {
    v7_relativeSplatPath: true,
    v7_startTransition: true,
};

function App() {
    const pathUrl = window.location.pathname;
    // Private candidate forms do not initialise staff sessions, sidebars, SSE,
    // feedback widgets or the staff-only mobile guard.
    if (pathUrl === '/pre-joining' || pathUrl === '/pre-joining/') {
        return <ConfigProvider theme={{ token: { fontFamily: 'Avenir, Arial, sans-serif' } }}><PrejoiningPage /></ConfigProvider>;
    }
    const routesExist = [
        "/recruit",
        "/checklist",
        "/chatbot",
        "/company-directory"
    ].some(route => pathUrl.includes(route));

    return (
        <ConfigProvider
            theme={{
                token: {
                    fontFamily: "Avenir",
                },
                cssVar: true,
                hashed: false,
            }}
        >
            <AntApp>
                <NewVersionWatcher />
                <div
                    className={`${
                        routesExist ? "App" : ""
                    } ${process.env.NODE_ENV === "production" ? "production" : ""} ${
                        pathUrl.includes("iframe") ? "iframe" : ""
                    }`}
                >
                    <BrowserRouter future={routerFutureFlags}>
                        <AuthProvider>
                            <ApiAvailabilityWatcher />
                            <FeedbackWidgetLoader />
                            <SSEProvider>
                                <SidebarProvider>
                                    <PageTitleProvider>
                                        <Store>
                                            <AppRouter />
                                            <ScrollToAnchor />
                                            <MobileViewportGuard />
                                        </Store>
                                    </PageTitleProvider>
                                </SidebarProvider>
                            </SSEProvider>
                        </AuthProvider>
                    </BrowserRouter>
                </div>
            </AntApp>
        </ConfigProvider>
    );
}

export default App;
